module.exports = __webpack_public_path__ + "static/media/chevron-up-solid.f48ca8c8.svg";